export default __webpack_public_path__ + "static/media/sporthub.5f67aab5.png";